import { render, staticRenderFns } from "./ListExternalCate.vue?vue&type=template&id=225bb914&scoped=true"
import script from "./ListExternalCate.vue?vue&type=script&lang=js"
export * from "./ListExternalCate.vue?vue&type=script&lang=js"
import style0 from "./ListExternalCate.vue?vue&type=style&index=0&id=225bb914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225bb914",
  null
  
)

export default component.exports